import { render } from "./AddCompanyComponent.vue?vue&type=template&id=41813357&scoped=true"
import script from "./AddCompanyComponent.vue?vue&type=script&lang=js"
export * from "./AddCompanyComponent.vue?vue&type=script&lang=js"

import "./AddCompanyComponent.vue?vue&type=style&index=0&id=41813357&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41813357"]])

export default __exports__